export default function CommentsSection() {
  const comments = [
    {
      id: 1,
      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20warm%20smile%2C%20soft%20lighting%2C%20simple%20background%2C%20chibi%20style%2C%20warm%20orange%20tones%2C%20clean%20illustration&width=120&height=120&seq=avatar-1-anime&orientation=squarish',
      name: '动漫达人小明',
      time: '2小时前',
      content: '在51动漫网上追了三年番了，这个入口真的太方便了，不用到处找资源。今天又发现了几部之前没注意到的冷门好番，推荐大家去看看《紫川》！国漫现在真的越来越好看了。',
      tag: '忠实用户',
    },
    {
      id: 2,
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20boy%20avatar%20with%20cool%20expression%2C%20modern%20style%2C%20warm%20lighting%2C%20simple%20background%2C%20clean%20anime%20illustration%2C%20orange%20accents&width=120&height=120&seq=avatar-2-anime&orientation=squarish',
      name: '追番狂魔阿强',
      time: '5小时前',
      content: '51动漫网站的更新速度绝了，昨晚《斗破苍穹》刚更新我就在51动漫主页上看到了。而且移动端体验也很不错，上班摸鱼的时候手机偷偷看一集，哈哈。希望平台越来越好！',
      tag: '活跃用户',
    },
    {
      id: 3,
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20girl%20avatar%20with%20gentle%20smile%2C%20soft%20art%20style%2C%20warm%20colors%2C%20simple%20background%2C%20clean%20illustration%2C%20pink%20and%20amber%20tones&width=120&height=120&seq=avatar-3-anime&orientation=squarish',
      name: '国漫守护者小雨',
      time: '1天前',
      content: '作为一个从《秦时明月》时代就开始追国漫的老粉，看着51动漫官网一步步成长起来真的很感慨。现在国漫题材越来越丰富，制作也越来越精良，51动漫这个入口平台功不可没，让我们能更方便地支持国产动漫！',
      tag: '资深漫迷',
    },
  ];

  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            漫迷之声
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            听听51动漫用户们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="font-heading text-sm text-foreground-950 truncate">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <span className="flex-shrink-0 ml-auto px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">
                  {comment.tag}
                </span>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}